module.exports = __webpack_public_path__ + "static/media/logo.5f1a0994.png";